export default __webpack_public_path__ + "static/media/autoconsumo-compartido-municipios.fbd8f34a.svg";